import { render, staticRenderFns } from "./DashboardCollectorIndex.vue?vue&type=template&id=00b99196&"
import script from "./DashboardCollectorIndex.vue?vue&type=script&lang=js&"
export * from "./DashboardCollectorIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports